import React from "react";
import { View } from "react-native";

import ChecklistItemModel from "./ChecklistItemModel";

export default function ChecklistItems({ currentStep }) {
  const steps = [
    { index: 1, text: "Introduction to Mana", duration: 5, isComplete: true },
    { index: 2, text: "Create an Account", duration: 2, isComplete: true },
    { index: 3, text: "Set up Profile", duration: 1, isComplete: false },
    { index: 4, text: "Set up Integrations", duration: 5, isComplete: false },
    { index: 5, text: "Customize Elements", duration: 5, isComplete: false },
  ];

  steps.forEach((step, index) => {
    step.isComplete = index <= currentStep;
  });

  return (
    <View style={{ width: "100%" }}>
      {steps.map((b, index) => (
        <ChecklistItemModel key={index} item={b} />
      ))}
    </View>
  );
}
